/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelSubscriptionDTO } from '../models/CancelSubscriptionDTO';
import type { ForgotPasswordBodyDTO } from '../models/ForgotPasswordBodyDTO';
import type { GooglePayload } from '../models/GooglePayload';
import type { IpInfoResponseDTO } from '../models/IpInfoResponseDTO';
import type { LocalizationInfoResponseDTO } from '../models/LocalizationInfoResponseDTO';
import type { MobilePayload } from '../models/MobilePayload';
import type { RegisterUserRequestDTO } from '../models/RegisterUserRequestDTO';
import type { ResetPasswordRequestDTO } from '../models/ResetPasswordRequestDTO';
import type { SurveyAnswerDto } from '../models/SurveyAnswerDto';
import type { UserDTO } from '../models/UserDTO';
import type { UserLoginRequestDTO } from '../models/UserLoginRequestDTO';
import type { UserUpdateDTO } from '../models/UserUpdateDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UsersService {
  /**
   * @param requestBody
   * @returns UserDTO Return new user entity, associated with the uniqueId
   * @throws ApiError
   */
  public static usersSignInMobile(
    requestBody: MobilePayload
  ): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/mobile',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `Returned when the register or login procedure fails`,
      },
    });
  }

  /**
   * Authenticate existing or create new Klangio Account using the google
   * login flow.
   * @param requestBody Payload fetched from google in frontend authentication
   * @returns UserDTO Authenticated User object
   * @throws ApiError
   */
  public static usersSignInGoogle(
    requestBody: GooglePayload
  ): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/google',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersLogin(
    requestBody: UserLoginRequestDTO
  ): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/login',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersRegister(
    requestBody: RegisterUserRequestDTO
  ): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/register',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id
   * @param token
   * @param appName
   * @returns binary
   * @throws ApiError
   */
  public static usersConfirmEmail(
    id?: string,
    token?: string,
    appName: string = 'piano2notes'
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/confirm',
      query: {
        id: id,
        token: token,
        appName: appName,
      },
    });
  }

  /**
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static usersForgotPassword(
    requestBody: ForgotPasswordBodyDTO
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/forgot',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static usersResetPassword(
    requestBody: ResetPasswordRequestDTO
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/reset',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get Information about the currently logged in user
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersMeGet(): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Users/me',
    });
  }

  /**
   * Get Information about the currently logged in user
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersMePost(): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/me',
    });
  }

  /**
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersGetAll(): CancelablePromise<Array<UserDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Users',
    });
  }

  /**
   * @param requestBody
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersUpdateUser(
    requestBody: UserUpdateDTO
  ): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Users',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Delete the authorized user and get back a list of
   * subscription Ids that cannot be cancelled from backend side.
   * @returns binary When user is deleted successfully
   * @throws ApiError
   */
  public static usersDelete(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Users',
      errors: {
        401: `User is not authenticated`,
        404: `When user cannot be found`,
      },
    });
  }

  /**
   * @param id
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersGetById(id: string): CancelablePromise<UserDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Users/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * @param requestBody
   * @returns binary Is returned when the call to Paddle API succeeded.
   * @throws ApiError
   */
  public static usersCancelSubscription(
    requestBody: CancelSubscriptionDTO
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/cancelSubscription',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Send when the Paddle API returns an Error on subscription cancellation.`,
        401: `User is not authenticated`,
        404: `Send when the user or the specified subscription cannot be found.`,
      },
    });
  }

  /**
   * Makes a user premium by assigning him the max. amount of
   * tickets and the minimum amount of used tickets.
   * Only meant for mobile users.
   * @returns void
   * @throws ApiError
   */
  public static usersMakeUserPremium(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/makePremium',
      errors: {
        401: `User is not authenticated`,
      },
    });
  }

  /**
   * Send answers and meta data of an answered survey by the user to the ai2notes backend.
   * @param requestBody Representation of data related to the users survey
   * @returns binary Survey answer has been received successfully
   * @throws ApiError
   */
  public static usersRegistrationSurvey(
    requestBody: SurveyAnswerDto
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Users/survey',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `User is not authenticated`,
      },
    });
  }

  /**
   * Get localization information based on the ip address the request is made from
   * @returns LocalizationInfoResponseDTO Localization information based on the ip address
   * @throws ApiError
   */
  public static usersGetLocalInfo(): CancelablePromise<LocalizationInfoResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Users/info',
      errors: {
        400: `Could not fetch information due to missing data`,
        429: `Could not fetch more information due to 429 response by third party api`,
      },
    });
  }

  /**
   * Get the ip address of the client making the request.
   * @returns IpInfoResponseDTO Localization information based on the ip address
   * @throws ApiError
   */
  public static usersGetIpInfo(): CancelablePromise<IpInfoResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Users/info/ip',
      errors: {
        400: `Could not fetch information due to missing data`,
      },
    });
  }
}
